import {CarouselAbstr, type CarouselOptions} from '../CarouselAbstr';
import {Slide} from '../Slide';

export class FeatureCarousel extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);
		this.init();
	}

	protected init(): void {
		const slides = this.carouselEl.querySelectorAll<HTMLElement>('.featureCarousel__slide');
		slides.item(0)?.classList.toggle('active', true);
		for (const slide of slides) {
			this.slides.push(new Slide(slide));
		}
		for (let i = 0; i < this.slides.length; i++){
			const slide = this.slides[i];
			const indicators = this.buildIndicators(i);
			if (indicators) {
				slide.element.querySelector(".featureCarousel__contentInner")?.appendChild(indicators);
			}
		}

		this.initAutoAdvance();
	}
}
